/* global MktoForms2 */

// Attempt to get the element using document.getElementById
const element = document.getElementById('marketoformactive');

// If it isn't "undefined" and it isn't "null", then it exists.
if (typeof (element) !== 'undefined' && element != null && MktoForms2) {
	MktoForms2.loadForm('//app-ab39.marketo.com', '238-OIJ-214', 1016, (form) => {
		// add hidden field
		// form.addHiddenFields({ banker: 'steve' });

		form.onSuccess(() => {
			// hide the form
			form.getFormElem().hide();

			console.log('submit success');

			// reveal hidden content
			const $reveal = document.getElementById('reveal');
			$reveal.style.display = 'block';

			const $hide = document.getElementById('hide');
			$hide.style.display = 'none';

			// Return false to prevent the submission handler from taking the lead to the follow up url
			return false;
		});
	});
}
